function isJSON(str: any) {
  if (typeof str === 'string') {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  }
  return false;
}

export class Storage {
  props: { source?: any };

  source: WindowLocalStorage;

  constructor(props?: { source?: any }) {
    this.props = props || {};
    this.source = (this.props.source || window) && window.localStorage;
  }

  get(key: string) {
    const data = this.source;
    const timeout = data[`${key}__expires__`] || 0;
    if (timeout === 0) {
      return data[key] && isJSON(data[key]) ? JSON.parse(data[key]) : data[key];
    }
    // 过期失效
    if (new Date().getTime() >= timeout) {
      this.remove(key);
      return undefined;
    }

    return data[key] && isJSON(data[key]) ? JSON.parse(data[key]) : data[key];
  }

  // 设置缓存
  // timeout：过期时间（分钟）
  set(key: string, value: object | string | number, timeout?: number) {
    const data = this.source;
    data[key] = JSON.stringify(value);
    if (timeout === 0) {
      return value;
    }
    if (timeout) {
      data[`${key}__expires__`] = new Date().getTime() + 1000 * 60 * timeout;
    }
    return value;
  }

  remove(key: string) {
    const data = this.source;
    const value = data[key];
    delete data[key];
    delete data[`${key}__expires__`];
    return value;
  }
}

const _storage = new Storage();

export default _storage;

/**
 * 使用 localStorage 存储一个当日有效的标记
 * 每日凌晨 0 点过期
 * @param storageKey {string} 标记名称，localStorage key
 */
export function everyDayOnceExpiredStorage(storageKey: string, value = 1) {
  // 凌晨 0 点过期
  const day = new Date();
  day.setDate(day.getDate() + 1);
  day.setHours(0, 0, 0, 0);
  const minutes = (day.getTime() - new Date().getTime()) / 1000 / 60;
  _storage.set(storageKey, value, minutes);
}
